import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector, dispatch } from '../../../redux/store';
// import { getNotification } from '../../../redux/slices/user';

const SlidingText = () => {
  useEffect(() => {
    // dispatch(getNotification());
  }, []);

  const state = useSelector((state) => state.user?.notification);

  const tds = state.some((e) => e?.title?.includes('TDS Return Due'));

  const txt1 = 'TDS Return Alert: Please file it before 31/07/2025 to avoid penalties';

  return (
    <Box
      sx={{
        width: '100%',
        height: '40px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        position: 'relative',
        backgroundColor: 'white',
        display: 'flex',
        alignItems: 'center',
        '& .scroll-text-1': {
          position: 'absolute',
          animation: 'slideRight1 12s linear infinite',
          whiteSpace: 'nowrap',
          color: 'red',
        },
        // '& .scroll-text-2': {
        //   position: 'absolute',
        //   animation: 'slideRight2 12s linear infinite',
        //   whiteSpace: 'nowrap',
        //   color: 'red',
        //   animationDelay: '10s', // 2nd line starts halfway through 1st
        // },
        '@keyframes slideRight1': {
          '0%': { left: '100%' },
          '100%': { left: '-100%' },
        },
        '@keyframes slideRight2': {
          '0%': { left: '-100%' },
          '100%': { left: '100%' },
        },
      }}
    >
      <Box className="scroll-text-1">
        <Box sx={{ display: 'flex', gap: 10 }}>
          {tds && <Typography sx={{ fontSize: '20px' }}>🚀 {txt1} 🚨</Typography>}
          {/* <Typography>
        🚀 Text 2: Hello from the left
        </Typography> */}
        </Box>
      </Box>
      {/* <Box className="scroll-text-2">🔥</Box> */}
    </Box>
  );
};

export default SlidingText;
